<!-- News: shown to everyone -->
<ng-template #newsCard>
  <div class="landing-dashboard-column landing-dashboard-column--auto" data-testid="landing-news">
    <div class="card-header">
      {{ "NEWS" | translate }}
    </div>
    <div class="card-body">
      @if (notifications.length > 0) {
        @for (notification of notifications; track notification) {
          <div>
            <div [ngClass]="notification.highlight ? 'notification-highlight' : ''">
              <strong>{{ notification.subject }}</strong><br />
              <small class="text-muted">{{ notification.timestamp | moment : "l LTS" }}</small>
              <p [innerHTML]="notification.message"></p>
            </div>
            <hr />
          </div>
        }
      }
    </div>
  </div>
</ng-template>

<h3 class="mt-3">{{ "NAV_DASHBOARD" | translate }}</h3>

@if (showDashboard) {
<div class="row landing-dashboard-row">
  <div class="col-md-12 mb-3 landing-dashboard-left-col">
    <div class="landing-dashboard-column landing-dashboard-column--auto mb-3">
      <div class="card-header">
        {{ "DEVICE_STATUS" | translate }}
      </div>
      <div class="card-body">
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [allowExclusion]="isLandingPageUser" [type]="'Online'" [class]="'statusOnline'" [data]="onlineStatus?.online" [title]="'Online' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [allowExclusion]="isLandingPageUser" [type]="'OfflineUnder24h'" [class]="'statusOfflineUnder'" [data]="onlineStatus?.offlineUnder24h" [title]="'OfflineUnder24h' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [allowExclusion]="isLandingPageUser" [type]="'OfflineOver24h'" [class]="'statusOfflineOver'" [data]="onlineStatus?.offlineOver24h" [title]="'OfflineOver24h' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [allowExclusion]="isLandingPageUser" [type]="'LowBattery'" [class]="'statusLowBattery'" [data]="onlineStatus?.lowBattery" [title]="'BATTERY_STATUS_WARNING' | translate" (onDeviceExcluded)="refreshOnlineStatus()"></devicestatus>
        <devicestatus [useCompanyGroup]="true" [disableRowClick]="true" [showCustomer]="true" [allowExclusion]="isLandingPageUser" [type]="'Excluded'" [class]="'statusExcluded'" [data]="onlineStatus?.excluded" [title]="'EXCLUDED_DEVICES' | translate" (onDeviceRemoved)="refreshOnlineStatus()"></devicestatus>
      </div>
    </div>
    <div class="mb-3">
      <app-active-alerts [showCustomer]="true" [cancelAllowed]="isLandingPageUser"></app-active-alerts>
    </div>

    <ng-container [ngTemplateOutlet]="newsCard"></ng-container>
  </div>
  <div class="col-md-12 mb-3 landing-dashboard-right-col">
    <div class="landing-dashboard-column">
      <div class="card-header">
        {{ "MOVE_TO" | translate }}
      </div>
      <div class="card-body p-0">
        @if (locationsLoaded) {
          @if (locations.length > 0) {
            <ul class="locations-list">
              @for (loc of locations; track loc.companyId) {
                <li class="location-item">
                  <strong>{{ loc.company }}</strong>
                  <span class="location-id">{{ loc.companyId }}</span>
                  <span class="location-address">{{ loc.address }}</span>
                </li>
              }
            </ul>
          } @else {
            <p class="p-3 text-muted">{{ "NO_INFORMATION_AVAILABLE" | translate }}</p>
          }
        } @else {
          <p class="p-3">{{ "LOADING" | translate }}...</p>
        }
      </div>
    </div>
  </div>
</div>
} @else {
<div class="row landing-dashboard-row">
  <div class="col-md-12 mb-3 landing-dashboard-left-col">
    <ng-container [ngTemplateOutlet]="newsCard"></ng-container>
  </div>
</div>
}
